import { render, staticRenderFns } from "./report.vue?vue&type=template&id=cf314ecc&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"
import style0 from "./report.vue?vue&type=style&index=0&id=cf314ecc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf314ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf314ecc')) {
      api.createRecord('cf314ecc', component.options)
    } else {
      api.reload('cf314ecc', component.options)
    }
    module.hot.accept("./report.vue?vue&type=template&id=cf314ecc&scoped=true", function () {
      api.rerender('cf314ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultation/report.vue"
export default component.exports